<template>
  <div class="modal fade slide-right"
       id="confirmModal"
       role="dialog"
       aria-hidden="true"
       data-backdrop="static">
    <div class="modal-dialog modal-sm modal-payment"
         style="width:500px;">
      <div class="modal-content-wrapper">
        <div class="modal-content"
             style="width:500px;height:100%;">
          <div class="modal-header clearfix text-left">
            <button type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-hidden="true">
              <i class="pg-close fs-14"
                 @click="$emit('close-modal')"></i>
            </button>
            <div class="col-md-12 modal-left">
              <h2 class="modal-title">Suppression d'un lead</h2>
            </div>
          </div>
          <div class="modal-body">
            <div class="col-md-12 modal-right">
              <notifications v-if="is_any_errors"
                             :errors="errors"
                             @close-error="reset_error($event)"
                             >
              </notifications>
              <p>
                Etes vous sur de vouloir supprimer ce lead ?
              </p>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-complete btn-cons" @click="delete_lead"
                    >Confirmer</button>
            <button type="button"
                    class="btn btn-default btn-cons no-margin inline"
                    data-dismiss="modal"
                    @click="$emit('close-modal')">Annuler
            </button>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex"
import Notifications from "components/CRM/Notifications"

export default {
  name:"DeletionModal",
  props:["lead_id"],
  components:{
    Notifications
  },
  mounted () {
    $(this.$el).modal()
  },
  beforeDestroy () {
    $(this.$el).modal('hide')
    $('body').removeClass('modal-open')
    $('.modal-backdrop').remove()
  },
  computed:{
    ...mapGetters("crm", ["is_any_errors","errors"]),
  },
  methods:{
    ...mapActions("crm", ["set_fetching_state", "fetch_all_leads","reset_error","reset_errors","remove_lead"]),
    delete_lead() {
      this.reset_errors()
      this.remove_lead({lead_id:this.lead_id})
          .then(() =>
            this.$router.push({name:"crm"}))
    }
  }
}

</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// client/components/CRM/DeleteModal.vue